/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dashboardStats.vue?vue&type=template&id=1de5e50d&scoped=true&"
import script from "./dashboardStats.vue?vue&type=script&lang=js&"
export * from "./dashboardStats.vue?vue&type=script&lang=js&"
import style0 from "./dashboardStats.vue?vue&type=style&index=0&id=1de5e50d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5e50d",
  null
  
)

export default component.exports